import type { CrudSchema } from '@/hooks/web/useCrudSchemas'
import { dateFormatter2 } from '@/utils/formatTime'
import { useCrudSchemas } from '@/hooks/web/useCrudSchemas'

/** 结束时间须晚于开始时间 */
export const createEndTimeAfterStartRule = (getStartTime: () => unknown) => ({
  validator: (_rule: unknown, value: unknown, callback: (e?: Error) => void) => {
    if (value == null || value === '') {
      callback(new Error('活动结束时间不能为空'))
      return
    }
    const start = getStartTime()
    if (start != null && start !== '' && Number(value) <= Number(start)) {
      callback(new Error('活动结束时间必须晚于开始时间'))
      return
    }
    callback()
  },
  trigger: 'change'
})

export const rules = reactive({
  spuId: [required],
  name: [required],
  startTime: [required],
  endTime: [required]
})

const crudSchemas = reactive<CrudSchema[]>([
  {
    label: '活动名称',
    field: 'name',
    isSearch: true,
    form: {
      colProps: { span: 24 }
    }
  },
  {
    label: '活动开始时间',
    field: 'startTime',
    formatter: dateFormatter2,
    form: {
      component: 'DatePicker',
      componentProps: {
        type: 'datetime',
        valueFormat: 'x'
      }
    }
  },
  {
    label: '活动结束时间',
    field: 'endTime',
    formatter: dateFormatter2,
    form: {
      component: 'DatePicker',
      componentProps: {
        type: 'datetime',
        valueFormat: 'x'
      }
    }
  },
  {
    label: '总限购',
    field: 'totalLimitCount',
    form: {
      component: 'InputNumber',
      value: 0,
      componentProps: { min: 0 }
    },
    isTable: false
  },
  {
    label: '单次限购',
    field: 'singleLimitCount',
    form: {
      component: 'InputNumber',
      value: 0,
      componentProps: { min: 0 }
    },
    isTable: false
  },
  {
    label: '备注',
    field: 'remark',
    form: {
      component: 'Input',
      componentProps: { type: 'textarea', rows: 2 },
      colProps: { span: 24 }
    },
    isTable: false
  },
  {
    label: '活动商品',
    field: 'spuId',
    isTable: false,
    isSearch: false,
    form: {
      colProps: { span: 24 }
    }
  }
])

export const { allSchemas } = useCrudSchemas(crudSchemas)
export const formSchema = allSchemas.formSchema
